import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

interface DecodedToken {
  exp: number;
  iat: number;
  sub: string;
  [key: string]: any;
}

export const tokenValidator = {
  /**
   * Check if token exists and is valid
   */
  isTokenValid(): boolean {
    const token = Cookies.get('accessToken');
    if (!token) return false;

    try {
      const decoded = jwtDecode<DecodedToken>(token);
      const currentTime = Date.now() / 1000;
      
      // Token is valid if not expired
      return decoded.exp > currentTime;
    } catch (error) {
      console.error('Token validation error:', error);
      return false;
    }
  },

  /**
   * Get token expiry time in seconds
   */
  getTokenExpiry(): number | null {
    const token = Cookies.get('accessToken');
    if (!token) return null;

    try {
      const decoded = jwtDecode<DecodedToken>(token);
      return decoded.exp;
    } catch (error) {
      console.error('Token decode error:', error);
      return null;
    }
  },

  /**
   * Get time until token expires in seconds
   */
  getTimeUntilExpiry(): number | null {
    const expiry = this.getTokenExpiry();
    if (!expiry) return null;

    const currentTime = Date.now() / 1000;
    return Math.max(0, expiry - currentTime);
  },

  /**
   * Check if token will expire soon (within specified minutes)
   */
  willExpireSoon(minutesThreshold: number = 5): boolean {
    const timeUntilExpiry = this.getTimeUntilExpiry();
    if (timeUntilExpiry === null) return false;

    const thresholdSeconds = minutesThreshold * 60;
    return timeUntilExpiry > 0 && timeUntilExpiry <= thresholdSeconds;
  },

  /**
   * Get decoded token payload
   */
  getDecodedToken(): DecodedToken | null {
    const token = Cookies.get('accessToken');
    if (!token) return null;

    try {
      return jwtDecode<DecodedToken>(token);
    } catch (error) {
      console.error('Token decode error:', error);
      return null;
    }
  }
};
